import { apiFetch } from "./client";

export interface ReportColumn {
  key: string;
  label: string;
}

export interface ReportResponse {
  report_type: string;
  columns: ReportColumn[];
  rows: Record<string, unknown>[];
}

export interface SavedReport {
  id: number;
  name: string;
  report_type: string;
  filters: Record<string, unknown>;
  owner_user_id: number | null;
  created_at: string;
}

export interface ReportFilters {
  date_from?: string;
  date_to?: string;
  status?: string;
}

export async function runReport(
  reportType: string,
  filters: ReportFilters = {},
): Promise<ReportResponse> {
  const qs = new URLSearchParams();
  if (filters.date_from) qs.set("date_from", filters.date_from);
  if (filters.date_to) qs.set("date_to", filters.date_to);
  if (filters.status) qs.set("status", filters.status);
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return apiFetch<ReportResponse>(`/reports/${reportType}${suffix}`);
}

/** Absolute URL for a downloadable export (CSV/XLSX); navigated to as a file download. */
export function exportReportUrl(
  reportType: string,
  format: "csv" | "xlsx",
  filters: ReportFilters = {},
): string {
  const qs = new URLSearchParams();
  qs.set("format", format);
  if (filters.date_from) qs.set("date_from", filters.date_from);
  if (filters.date_to) qs.set("date_to", filters.date_to);
  if (filters.status) qs.set("status", filters.status);
  return `/api/v1/reports/${reportType}/export?${qs.toString()}`;
}

export async function listSavedReports(): Promise<SavedReport[]> {
  return apiFetch<SavedReport[]>("/reports/saved");
}

export async function createSavedReport(data: {
  name: string;
  report_type: string;
  filters: ReportFilters;
}): Promise<SavedReport> {
  return apiFetch<SavedReport>("/reports/saved", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function deleteSavedReport(id: number): Promise<unknown> {
  return apiFetch(`/reports/saved/${id}`, { method: "DELETE" });
}
